import React from 'react';
import {useFormik, FormikContext} from "formik";
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import {setGetBonusesPersonal} from '../../store/thunk/setGetBonusesPersonal';
import {setPostIssuePersonal} from '../../store/thunk/setPostIssuePersonal';
import DialogSuccess from '../../../bonuses/components/dialog-success';
import DialogErrors from '../../../bonuses/components/dialog-errors';
import {useStyles} from './helpers';
import Title from '../../../../../@casino/ui/title';

const CreateBonusPersonal = ({selectId, setStep, setSelectId}) => {
    const [openModal, setOpenModal] = React.useState(false);
    const [openModalErrors, setOpenModalErrors] = React.useState(false);

    const classes = useStyles();
    const dispatch = useDispatch();
    const listPersonalBonuses = useSelector(state => state.personal.list);

    const initialValues = {
        select_gamer: selectId,
        bonuses: listPersonalBonuses && listPersonalBonuses.length ? listPersonalBonuses[0].bonus_name : '',
        cause: ''
    }

    const onSubmit = (store) => {
        dispatch(setPostIssuePersonal(store, setOpenModal, setStep, setOpenModalErrors, setSelectId));
    }

    React.useEffect(() => {
        dispatch(setGetBonusesPersonal());
    }, [])

    const enableReinitialize = true;

    const formik = useFormik({onSubmit, initialValues, enableReinitialize});
  
    return (
        <div 
            className={classes.color}
        >
            <Title label="Выдача персонального бонуса" />
            <FormikContext.Provider value={formik}>
                <form 
                    onSubmit={formik.handleSubmit}
                >
                    <label 
                        htmlFor="select_gamer" 
                        className={clsx(classes.wrapLabel, classes.beginBonusLabel)}
                    >
                        <span 
                            className={classes.helper}
                        >
                            Выбранные игроки
                        </span>
                        <div 
                            className={classes.selectList}
                        >
                            {
                                selectId.map((item) => (
                                    <span
                                        className={classes.selectItem}
                                    >
                                            ID {item}
                                    </span>
                                ))
                            }
                        </div>
                    </label>
                    <label 
                        htmlFor="bonuses" 
                        className={clsx(classes.wrapLabel, classes.beginBonusLabel)}
                    >
                        <span 
                            className={classes.helper}
                        >
                            BONUSES
                        </span>
                        <select 
                            id="template"
                            name="template" 
                            className={classes.select}
                            value={formik.values.bonuses} 
                            onChange={(v) => formik.setFieldValue('bonuses', v.target.value)}
                        >
                            {
                                listPersonalBonuses.map(item => (
                                    <option 
                                        value={item.bonus_name}
                                    >
                                        {item.bonus_name}
                                    </option>
                                ))
                            }
                        
                        </select>
                    </label>
                    <label 
                        htmlFor="cause" 
                        className={clsx(classes.wrapLabel, classes.beginBonusLabel)}
                    >
                        <span
                            className={classes.helper}
                        >
                            Причина выдачи бонуса
                        </span>
                        <textarea 
                            name="cause" 
                            id="cause" 
                            cols="30" 
                            rows="10" 
                            className={classes.textarea}
                            value={formik.values.cause} 
                            onChange={(v) => formik.setFieldValue('cause', v.target.value)}>
                        </textarea>
                    </label>
                    <div>
                        <span 
                            className={classes.btn}
                            onClick={() => formik.submitForm()}
                        >
                            Выдать
                        </span>
                    </div>
                </form>
            </FormikContext.Provider>
            <DialogSuccess setOpenModal={setOpenModal} openModal={openModal} label="Бонус выдан"/>
            <DialogErrors setOpenModal={setOpenModalErrors} openModal={openModalErrors} label="Бонус не выдан"/>
        </div>
    )
}

export default CreateBonusPersonal;